/**
 * Detecta intentos de Inyección SQL y XSS (Cross-Site Scripting) en una cadena de texto.
 * Utiliza patrones y Regex rigurosos para neutralizar vectores comunes de ataque.
 * @param {string} value - El texto a validar.
 * @returns {Promise<boolean>} - True si se detecta una amenaza, False si es seguro.
 */
const ValidateSqlInjection = async (value) => {
    try {
        if (!value) return false;

        const stringValue = String(value);
        const upperValue = stringValue.toUpperCase();

        // 1. Lista de palabras clave reservadas de SQL que no deberían estar en un mensaje normal
        // Se buscan palabras completas para evitar falsos positivos (ej: "INSERTAR" contiene "INSERT")
        const sqlKeywords = [
            'DROP TABLE', 'DELETE FROM', 'INSERT INTO', 'UPDATE ', 'TRUNCATE TABLE', 
            'ALTER TABLE', 'EXEC(', 'EXECUTE(', 'UNION ALL', 'UNION SELECT'
        ];

        // 2. Caracteres peligrosos comunes en ataques (comentarios, terminadores)
        // El punto y coma (;) es peligroso si se usa para encadenar comandos.
        // Los guiones dobles (--) se usan para comentar el resto de la query.
        const dangerousCharacters = [';', '--', '/*'];

        // Verificación 1: Palabras clave compuestas
        const hasKeyword = sqlKeywords.some(keyword => upperValue.includes(keyword));

        // Verificación 2: Caracteres de control
        const hasDangerousChars = dangerousCharacters.some(char => stringValue.includes(char));

        // Verificación 3: Patrón común de ataque booleano (ej: "OR 1=1", "' OR '1'='1", "OR 'a'='a'")
        const hasBooleanAttack = /\bOR\s+['"]?([^'"\s=]+)['"]?\s*=\s*['"]?\1['"]?/i.test(stringValue) ||
                                 /\bOR\s+\d+=\d+/i.test(stringValue) ||
                                 /'\s*OR\s*['"]?1['"]?\s*=\s*['"]?1/i.test(stringValue);

        // Verificación 4: Patrones comunes de XSS (Cross-Site Scripting)
        const xssPatterns = [
            /<script\b[^>]*>/i,
            /<\/script>/i,
            /javascript\s*:/i,
            /\bon\w+\s*=/i,
            /<iframe\b[^>]*>/i
        ];
        const hasXss = xssPatterns.some(pattern => pattern.test(stringValue));

        return hasKeyword || hasDangerousChars || hasBooleanAttack || hasXss;

    } catch (error) {
        console.error("Error en ValidateSqlInjection:", error);
        // En caso de error en la validación, por seguridad asumimos que es peligroso (Fail Safe)
        return true; 
    }
};

export { ValidateSqlInjection };









// /**
//  * Función para detectar inyección SQL (ejemplo básico)
//  * @param {string} value 
//  * @returns 
//  */
// const ValidateSqlInjection = async (value) => {
//     try {    
//         const sqlInjectionKeywords = ['SELECT', 'INSERT', 'UPDATE', 'DELETE'] //';', '--', 'DROP'
        
//         return sqlInjectionKeywords.some(keyword => value.toUpperCase().includes(keyword))
//     } catch (error) {
//         await LogErrors('ValidateSqlInjection - BL Security', error)
//     }
// }

// export { ValidateSqlInjection };